<template>
  <div
    @click="selectBall(ball)"
    class="betting-ball"
    :class="{is__active : ball.status}">
    <div class="ball-number">
      {{ ball.number }}
    </div>
  </div>
</template>

<script>
import { BettingSvc } from "../../services/betting.service";
import { GameSvc } from "../../services/game.service";
import { GatewaySvc } from '../../services/gateway.service';
import { TranslationSvc } from '../../services/translation.service';
import { EventBus } from "../../utilities/event.bus";

export default {
  name: "Ball",
  props: ["ball"],
  methods: {
    selectBall(ball) {
      const bettingSvc = BettingSvc.getBettingSvc();
      const gameSvc = GameSvc.getGameSvc();
      const maxAllInNumbers = gameSvc.rules.maxAllInNumbers.value;
      const maxNoDrawNumbers = gameSvc.rules.maxNoDrawNumbers.value;
      const maxSystemNumber = gameSvc.rules.maxSystemNumber.value;
      const numberOfSpots = gameSvc.spotNumber;

      EventBus.$emit("Keno.ClearSpecialBettings");

      if (![40, 41].includes(bettingSvc.specialBetType)) {
        bettingSvc.clearSpecialBets();
      }

      bettingSvc.type = "normal";
      bettingSvc.system = "";

      if (!bettingSvc.ticket.input.length) {
        bettingSvc.ticket.input = [];
      }

      // Set NO DRAW bet since it's the only chioce in this selection range
      if (sevenConfig.data.dp.toLowerCase() === 'terminal') {
        const ballsSelectedBefore = bettingSvc.ticket.input.length;
        const ballsSelectedAfter = ball.status ? ballsSelectedBefore - 1 : ballsSelectedBefore + 1;

        if (ballsSelectedAfter > maxSystemNumber && ballsSelectedAfter <= maxNoDrawNumbers) {
          bettingSvc.terminalSpecialBet({target: { id: 40 } }, bettingSvc, bettingSvc.specialBetType !== 40);
        } else if (bettingSvc.specialBetType === 40 && ballsSelectedAfter < maxNoDrawNumbers) {
          bettingSvc.terminalSpecialBet({target: { id: 40 } }, bettingSvc, 'click');
          bettingSvc.specialBetType = 0;
        }
      }

      if (bettingSvc.ticket.input.indexOf(ball.number) >= 0) {
          bettingSvc.ticket.input.splice(bettingSvc.ticket.input.indexOf(ball.number), 1);
          ball.status = !ball.status;
          if (!bettingSvc.ticket.input.length) {
            bettingSvc.deactivateNumbersSpecialBet();
          }
          return;
      }

      const getMaxNumbers = () => {

        if (bettingSvc.specialBetsActiveStatus[41]) {
          return maxAllInNumbers;
        }

        if (bettingSvc.specialBetsActiveStatus[40]) {
          return maxNoDrawNumbers;
        }

        if (sevenConfig.data.config.bets[40].value &&
          (maxNoDrawNumbers > numberOfSpots) && (maxNoDrawNumbers > maxSystemNumber)) {
          return maxNoDrawNumbers;
        }

        return Math.max(numberOfSpots, maxSystemNumber);
      }

      if (bettingSvc.ticket.input.length >= getMaxNumbers()) {
        GatewaySvc.getGatewaySvc().showDialog({
            message: TranslationSvc.getTranslation('max_numbers', getMaxNumbers()),
            type: 'warning'
        });
        return;
      }

      ball.status = !ball.status;
      bettingSvc.ticket.input.push(ball.number);
    }
  }
};
</script>

<style lang="scss">
.betting-ball {
  display: inline-block;
  width: 9%;
  height: 7.5vh;
  line-height: 7.5vh;
  margin-top: 5px;
  border: 2px;
  text-align: center;
  vertical-align: middle;
  transition: 0.45s ease;
  transition-delay: 0.025s;
  color: #acacad;
  cursor: pointer;
  margin-right: 5px;
  border-radius: 2px;
  background-color: #404040;
  box-shadow: 1px 1.7px 7px 0 rgba(0, 0, 0, 0.2);
}

.is__active {
  background-color: #0066ae;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// Ball.vue?3ac51bd5